import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const t = testimonials[current];

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-foreground-950">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-background-50 text-center mb-12 md:mb-16">
          (What Our Clients Say)
        </h2>

        <div className="relative">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10">
            <div className="flex items-center gap-2 mb-6">
              <span className="inline-flex items-center gap-1.5 bg-foreground-950 text-background-50 px-3 py-1.5 rounded-full text-xs font-medium">
                <i className="ri-star-fill text-accent-500"></i>
                {t.rating}.0
              </span>
            </div>

            <p className="font-heading text-lg md:text-xl text-foreground-700 leading-relaxed mb-8">
              &ldquo;{t.text}&rdquo;
            </p>

            <div className="flex items-center gap-4">
              <div>
                <p className="font-medium text-foreground-950 text-sm">
                  {t.name}
                </p>
                <p className="text-xs text-foreground-500">{t.location}</p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end gap-2 mt-6">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-lg border border-background-300/30 bg-background-50/10 flex items-center justify-center hover:bg-background-50/20 transition-colors cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line text-background-50"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 rounded-lg bg-background-50 text-foreground-950 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}